const NodeRSA = require('node-rsa');
module.exports = {
    encryptFrame: (frameData, customerPublicKey, encoding = "base64") => {
        let customerPublicRSA = new NodeRSA(customerPublicKey)
        return customerPublicRSA.encrypt(frameData, encoding)
    },
    decryptFrame: (encryptedData, customerPrivateKey, encoding = "utf-8") => {
        let customerPrivateRSA = new NodeRSA(customerPrivateKey)
        return customerPrivateRSA.decrypt(encryptedData, encoding)
    },
    getRSA: () => {
        return new NodeRSA({ b: 512 })
    },
    getPublicKey: (objNodeRSA) => {
        return objNodeRSA.exportKey('pkcs8-public')
    },
    getPrivateKey: (objNodeRSA) => {
        return objNodeRSA.exportKey('pkcs8-private')
    }
}